import { CardContainer } from "@src/components/cards";
import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Checkbox,
  DropDown,
  Icon,
  Loader,
} from "@src/components/atoms";
import AppUtils from "@src/utils/appUtils";
import { useAuthContext } from "@src/context";
import AdminHooks from "@src/context/hooks/adminHooks";
import UsersTable from "@src/components/tables/admin/UsersTable";

export const UsersSection = ({ customerCode }) => {
  const auth = useAuthContext();
  const navigate = useNavigate();

  const onUserClick = (e) => {
    navigate(`/dashboard/admin/users/${e.id}`);
  };

  const handleDeactivate = (e) => {
    console.log("handle deactivating the user", e);
    alert("Not implemented yet");
    //TODO - implement user deactivation
  };

  const {
    data: users,
    isPending,
    isError,
    //error: errorAll,
  } = AdminHooks.useGetOperators(auth.activeRole, customerCode);

  return (
    <div className="p-2 flex flex-col gap-4">
      {isPending && <Loader size="2xl" />}

      {!isPending && isError && (
        <div className="text-center">Error fetching users...</div>
      )}
      {!isPending && !users?.length && (
        <div className="text-center">No users to display</div>
      )}
      {!isPending && users?.length > 0 && (
        <UsersTable
          users={users}
          onEdit={onUserClick}
          handleDeactivate={handleDeactivate}
        />
      )}
    </div>
  );
};
